import { DecimalPipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil } from 'rxjs';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { MaterialPresupuesto } from 'src/app/shared/models/material-presupuesto';

@Component({
  selector: 'app-materiales-presupuesto',
  templateUrl: './materiales-presupuesto.component.html',
  styleUrls: ['./materiales-presupuesto.component.css'],
  providers: [DecimalPipe]
})
export class MaterialesPresupuestoComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  private route: string;
  private method: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  listMaterialesPresupuesto: MaterialPresupuesto[] = [];

  filterDetails = new FormControl('0');
  descriptionFilter = new FormControl({ value: '', disabled: true });
  descriptionSearch = new FormControl({ value: '', disabled: false });
  filterDictionary = new Map<string | null, string | null>();
  filterValue: string;

  dataSourceFilters = new MatTableDataSource<MaterialPresupuesto>;
  displayedColumns: string[] = ['reference', 'description', 'unit', 'price', 'waste', 'materialFamily', 'supplier'];
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public pBudgetId: number,
    public dialogMaterialesPresupuestoRef: MatDialogRef<MaterialesPresupuestoComponent>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private decimalPipe: DecimalPipe
  ) { }

  ngOnInit() {
    this.loadListMaterialBudget();
    this.dataSourceFilters.filterPredicate = function (record, filter) {
      var map = new Map(JSON.parse(filter));
      let isMatch = false;
      for (let [key, value] of map) {
        if (key as keyof MaterialPresupuesto === 'materialFamily') {
          isMatch = (record.materialFamily || '').trim().toLowerCase().indexOf(value as keyof MaterialPresupuesto) !== -1;
        } else if (key as keyof MaterialPresupuesto === 'description') {
          isMatch = (record.description || '').trim().toLowerCase().indexOf(value as keyof MaterialPresupuesto) !== -1;
        } else if (key as keyof MaterialPresupuesto === 'reference') {
          isMatch = (record.reference || '').trim().toLowerCase().indexOf(value as keyof MaterialPresupuesto) !== -1;
        } else if (key === "0") {
          isMatch = (record.reference || '').trim().toLowerCase().indexOf(value as keyof MaterialPresupuesto) !== -1
            || (record.description || '').trim().toLowerCase().indexOf(value as keyof MaterialPresupuesto) !== -1
            || (record.unit || '').trim().toLowerCase().indexOf(value as keyof MaterialPresupuesto) !== -1
            || String(record.price).toString().indexOf(value as keyof MaterialPresupuesto) !== -1
            || String(record.waste).toString().indexOf(value as keyof MaterialPresupuesto) !== -1
            || (record.supplier || '').trim().toLowerCase().indexOf(value as keyof MaterialPresupuesto) !== -1
            || (record.materialFamily || '').trim().toLowerCase().indexOf(value as keyof MaterialPresupuesto) !== -1

        } else if (value === '') {
          isMatch = true;
        };
        if (!isMatch) return false;
      }
      return isMatch;
    };
  }

  ngAfterViewInit() {
    this.dataSourceFilters.sort = this.sort;
  }

  loadListMaterialBudget() {
    this.listMaterialesPresupuesto = [];
    this.route = '/getMaterialByBudgetLineItem';
    this.method = 'POST';
    let data = {
      idBudget: this.pBudgetId
    }
    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          for (let [i, materialResponse] of response.data.entries()) {
            let material: MaterialPresupuesto = {
              reference: materialResponse.materialCode,
              description: materialResponse.materialDescription,
              unit: materialResponse.unitDescription,
              price: materialResponse.price,
              waste: materialResponse.ratio,
              materialFamily: materialResponse.materialFamilyName,
              supplier: (materialResponse.supplierName ? materialResponse.supplierName : '')
            };
            this.listMaterialesPresupuesto.push(material);
          }
          this.dataSourceFilters.data = this.listMaterialesPresupuesto;
          this.apiCallService.hideSpinner();
        } else {
          this.closeDialogMaterialesPresupuesto();
          this.apiCallService.hideSpinner();
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
      });
  }

  cleanFilter() {
    this.descriptionFilter.setValue('');
    this.descriptionSearch.setValue('');
    if (this.filterDetails.value === '0') {
      this.descriptionFilter.disable();
      this.descriptionSearch.enable();
    } else {
      this.descriptionFilter.enable();
      this.descriptionSearch.disable();
    }
  }

  applyFilterDetails(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    this.filterDictionary.set(this.filterDetails.value, this.filterValue);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.dataSourceFilters.filter = jsonString;

    if (this.dataSourceFilters.paginator) {
      this.dataSourceFilters.paginator.firstPage();
    }
  }

  closeDialogMaterialesPresupuesto() {
    this.dialogMaterialesPresupuestoRef.close();
  }

}
